import React from 'react';
import { useState } from 'react';
import { isSafari } from "react-device-detect";
import styles from './styles/cover.module.scss';
import json_cover_en from './jsons/en/cover_en.json';
import json_cover_pt from './jsons/pt/cover_pt.json';
import desktop_video from './resources/videos/pexels-pavel-danilyuk-6688263_cropped_flipped_slow_2.mp4';
import mobile_video from './resources/videos/pexels-pavel-danilyuk-6688263_cropped_flipped_slow_2_mobile.mp4';

const Cover = () => {

    //////////////////////////////////////////////////////////////////////////
    // VARIABLES
    //////////////////////////////////////////////////////////////////////////
    // json data
    const video_or_image = "video";
    const [language, set_language] = useState(localStorage.getItem("language"));
    const json_data = language === "EN" ? json_cover_en : json_cover_pt;
    const [window_width, set_window_width] = useState(window.innerWidth);
    const max_width = parseInt(getComputedStyle(document.body).getPropertyValue('--max_width').split("px")[0]);

    // listen for language changes
    window.addEventListener('language', () => {
        set_language(localStorage.getItem("language"));
    });

    // listen for window width changes
    window.addEventListener('resize', () => { 
        set_window_width(window.innerWidth); 
    });

    return ( 
        <div className = {styles.root}>
            {video_or_image === "video" ?
                <div 
                    className = {styles.root_background}
                    style = {{
                        backgroundImage: `url(${require(`${(window_width < 600 ? json_data.mobile_video : json_data.desktop_video)}`)})`,
                        //backgroundImage: `url(${require(`${(window_width < 600 ? json_data.mobile_image : json_data.desktop_image)}`)})`,
                        marginLeft: (window_width <= max_width ? "0": "calc(((100vw - var(--max_width)) / 2) * -1)"),
                    }}>
                    {!isSafari ? 
                    <video className = {styles.root_background_video} autoPlay muted playsinline loop>
                        <source src = {window_width < 600 ? mobile_video : desktop_video} type = "video/mp4"/>
                    </video> : <></>}
                </div>
                :
                <div 
                    className = {styles.root_background}
                    style = {{
                        backgroundImage: `url(${require(`${(window_width < 600 ? json_data.mobile_image : json_data.desktop_image)}`)})`,
                        marginLeft: (window_width <= max_width ? "0": "calc(((100vw - var(--max_width)) / 2) * -1)"),
                    }} />
            }

            <div 
                className = {styles.root_background_fade}
                style = {{
                    marginLeft: (window_width <= max_width ? "0": "calc(((100vw - var(--max_width)) / 2) * -1)"),
                }}/>
            <div className = {styles.main_text_div}>
                <span 
                    className = {styles.white_text}
                    style = {{
                        fontSize: (window_width < 900 ? (window_width < 500 ? "44px" : "55px") : "70px"),
                        marginLeft: (window_width <= (max_width + 100) ? "50px" : "0px"),
                    }}>
                    {json_data.first_part_text}
                </span>
                <span 
                    className = {styles.white_text}
                    style = {{
                        fontSize: (window_width < 900 ? (window_width < 500 ? "44px" : "55px") : "70px"),
                        marginLeft: (window_width <= (max_width + 100) ? "50px" : "0px"),
                    }}>
                    {json_data.second_part_text}
                </span>
                <span 
                    className = {styles.red_text}
                    style = {{
                        fontSize: (window_width < 900 ? (window_width < 500 ? "44px" : "55px") : "70px"),
                        marginLeft: (window_width <= (max_width + 100) ? "50px" : "0px"),
                    }}>
                    {json_data.third_part_text}
                </span>
            </div>
        </div>
    );
}

export default Cover;